import React from 'react';
import { Link } from 'react-router-dom';
import './Holiday.css';

// Real StarView-only differentiators - the movie-tie-in concession promos
// this replaced (a "Dino Fizz," a "Menacing Drink") weren't anything
// StarView actually built; these are the platform's real features (the
// theater-lobby trailer-loop countdown, in-seat OrderUp delivery, Galaxies
// rewards, StarView X, and the premium formats already listed in the
// footer's Movies column) - genuinely "only at StarView."
const onlyAtStarView = [
  {
    title: 'The Theater Lobby',
    icon: 'lobby',
    desc: "Every auditorium has its own real lobby - trailers loop on the big screen while a live countdown ticks down to your exact showtime, so you're never staring at a blank room.",
    badge: 'SIGNATURE',
    cta: 'See Showtimes',
    to: '/Showtimes',
  },
  {
    title: 'OrderUp, To Your Seat',
    icon: 'delivery',
    desc: 'Order from real local restaurants without leaving the lobby - your food is delivered straight to your seat, tracked live from Order Received to Delivered.',
    badge: 'IN-SEAT DELIVERY',
    cta: 'Order With Tickets',
    to: '/Showtimes',
  },
  {
    title: 'Galaxies Rewards',
    icon: 'galaxy',
    desc: 'Every ticket earns real Galaxies - redeem them for free movies, StarBucks and Dunkin gift cards, flight credits, even a beachfront Hawaii vacation.',
    badge: 'LOYALTY',
    cta: 'See Current Offers',
    to: '/Offers',
  },
  {
    title: 'StarView X Membership',
    icon: 'crown',
    desc: 'A free movie ticket plus a free medium popcorn every month, exclusively for StarView X members - on top of everything else Galaxies already earns you.',
    badge: 'MEMBERSHIP',
    cta: 'See Current Offers',
    to: '/Offers',
  },
];

const ICONS = {
  lobby: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="14" width="52" height="34" rx="4" stroke="currentColor" strokeWidth="2.5" />
      <path d="M6 40C16 34 48 34 58 40" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="47" cy="21" r="4" stroke="currentColor" strokeWidth="2.5" />
      <path d="M14 48V54M50 48V54" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  delivery: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="24" width="30" height="22" rx="3" stroke="currentColor" strokeWidth="2.5" />
      <path d="M40 30H50L56 38V46H40V30Z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <circle cx="20" cy="50" r="4" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="48" cy="50" r="4" stroke="currentColor" strokeWidth="2.5" />
      <path d="M17 24V16H27" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  galaxy: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="10" stroke="currentColor" strokeWidth="2.5" />
      <ellipse cx="32" cy="32" rx="26" ry="9" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="14" cy="16" r="2" fill="currentColor" />
      <circle cx="52" cy="20" r="1.6" fill="currentColor" />
      <circle cx="50" cy="48" r="2" fill="currentColor" />
    </svg>
  ),
  crown: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 46L14 22L26 34L32 18L38 34L50 22L54 46H10Z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M10 46H54" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
};

const HolidayPromo = () => {
  return (
    <div className="holiday-container">
      <h2 className="holiday-heading">Only At StarView</h2>
      <div className="holiday-content">
        {onlyAtStarView.map((promo, i) => (
          <div key={promo.title} className={`promo-card${i % 2 === 1 ? ' promo-card--reverse' : ''}`}>
            <div className="promo-card-image-wrapper">
              <span className="promo-badge">{promo.badge}</span>
              <div className="promo-card-icon-tile" aria-hidden="true">{ICONS[promo.icon]}</div>
            </div>
            <div className="promo-card-content">
              <p className="promo-card-title">{promo.title}</p>
              <p className="promo-card-desc">{promo.desc}</p>
              <Link to={promo.to} className="promo-card-btn">{promo.cta}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolidayPromo;
